export { AgileFooterTop, type ComponentStyleProps } from "./agile-footer-top";
export { AgileFooter, type AgileFooterPatternProps } from "./agile-footer";
export { AgileFooter as default } from "./agile-footer";
